import { render, staticRenderFns } from "./Agents-table.vue?vue&type=template&id=ec2fe984"
import script from "./Agents-table.vue?vue&type=script&lang=js"
export * from "./Agents-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports